import * as React from 'react';
import styled from '@emotion/styled';
import { style } from './RecommendationSection';
import { AnchorIcon } from '../Icons/AnchorIcon';
import { CalendarIcon } from '../Icons/CalendarIcon';
interface IProps {
    region: string;
    calendar: string;
}

const sharedIconStyles = ({ theme }) => `
    float: left;
    marginRight: 5px;
    fill: ${theme.icon.brandColor1};
    flex: 0 0 auto;
`;

const StyledAnchorIcon = styled(AnchorIcon)`
    ${sharedIconStyles}
`;
const StyledCalendarIcon = styled(CalendarIcon)`
    ${sharedIconStyles}
`;

export const CruiseRecommendationDescRegular = (props: IProps) => {
    return (
        <div style={style.cardInfo}>
            <div style={style.spacingBottom}>
                <StyledAnchorIcon width={18} height={18} />
                <span className="overflow-ellipsis--single-line" style={style.teaserText}>
                    {props.region}
                </span>
            </div>
            <div style={style.spacingBottom}>
                <StyledCalendarIcon width={18} height={18} />
                <span className="overflow-ellipsis--single-line" style={style.teaserText}>
                    {props.calendar}
                </span>
            </div>
        </div>
    );
};
